var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRuler = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "50px",
  height: "50px",
  viewBox: "0 0 50 50",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Ruler_3201330",
  transform: "translate(-5.000000, 0.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.7099915,11.3050232 L48.6200257,17.4049988 L45.2099915,13.9950257 C44.8199769,13.5950013 44.1800232,13.6050111 43.7900086,13.9950257 C43.399994,14.3850403 43.399994,15.0149842 43.7900086,15.4049988 L47.1999817,18.815033 L42.4200134,23.605011 L39.7799988,20.9549866 C39.3799744,20.565033 38.7499695,20.565033 38.3600159,20.9549866 C37.9700013,21.3450012 37.9700013,21.9850159 38.3600159,22.3750305 L40.9999695,25.0149841 L36.2200012,29.8050232 L32.809967,26.394989 C32.4200134,25.9950256 31.7799987,26.0050354 31.3899841,26.394989 C30.9999695,26.7850036 30.9999695,27.4150085 31.3899841,27.8050232 L34.8000183,31.2149963 L30.019989,36.0050354 L27.3799744,33.355011 C26.980011,32.9649964 26.3500061,32.9649964 25.9599915,33.355011 C25.5699769,33.7450256 25.5699769,34.3850403 25.9599915,34.7749939 L28.6000061,37.4150085 L23.8199768,42.2049865 L20.4100037,38.7950134 C20.0199891,38.4049988 19.3799744,38.4049988 18.9900208,38.7950134 C18.6000062,39.185028 18.6000062,39.8150329 18.9900208,40.2049865 L22.3999939,43.6150207 L16.309967,49.7049865 C15.9200134,50.0950011 15.2799987,50.0950011 14.8899841,49.7049865 L5.2900085,40.105011 C4.8999939,39.7149964 4.8999939,39.0849915 5.2900085,38.6950379 L43.6899719,0.2950134 C44.0799865,-0.0950012 44.7200012,-0.0950012 45.1100158,0.2950134 L54.7099914,9.894989 C55.1000061,10.2850037 55.1000061,10.9150085 54.7099915,11.3050232 Z",
  id: "Shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRuler);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ruler.7627dbba2e0a6cad6aec97963697d4cc.svg";